import { Injectable, signal } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
// import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { MenuItem, MessageService } from 'primeng/api';
import { catchError, lastValueFrom, map, Observable, of, Subject, takeUntil } from 'rxjs';
import { saveAs } from 'file-saver';
import { USER_MGMT_CNST } from '../constants/proj.cnst';
import { Config } from '../enums';
import { AuthenticationService } from '../modules/authentication/services/authentication.service';
// import { isNullOrUndefined } from '../modules/shared/common-utils';
import { InitService } from '../parsers/init.service';
import { AppStateService } from '../services/app-state.service';
import { EnvService } from './env.service';
import { HttpService } from './http.service';
// import { environment } from '../modules/shared/environments/environment.dev';
import { HttpClient } from '@angular/common/http';
import { KeycloakService } from './keycloak.service';
import { environment } from '../shared/environments/environment.dev';
import { isNullOrUndefined } from '../shared/common-utils';
/**
 * NOTE: .
 * Use this service to write some common formatters which can be shared across projects..
 * Don't write chart/table formatters here.
 *
 * EXAMPLE:
 *  - Generating a UUID.
 *  - Date Utils
 *  etc..
 */
@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  private activeSpinnerCount = 0;
  loader = signal<boolean>(false);
  public destroy$ = new Subject<void>();

  constructor(
    private httpSrv: HttpService,
    // private toastr: ToastrService,
    private messageService: MessageService,
    private intitSrv: InitService,
    private keyCloakSrv: KeycloakService,
    private appStateSrv: AppStateService,
    private authSrv: AuthenticationService,
    private envService: EnvService,
    private router: Router,
    private http: HttpClient
  ) { }

  async checkUser(userId: string): Promise<boolean> {
    let promise: Promise<boolean> = new Promise((resolve) => {

      if (!userId) resolve(false);

      this.httpSrv
        .makePostApiCall('CHECK_IF_DANA_USER', { userId }, this.envService.baseUrl)
        .subscribe({
          next: () => {
            resolve(true);
          },
          error: (error) => {
            this.showToastMessage(error, 'error');
            resolve(false);
          }
        })
    })
    return promise;
  }

  showToastMessage(message: string, type: string, options?: any): void {
    this.messageService.add({ severity: type, summary: type.replace(/^\w/, (c) => c.toUpperCase()), detail: message });
  }


  handleSuccess(res: any) {
    let config = this.intitSrv.getConfig(Config.OTP_FORGOT_PASSWD_CONFIG)
    let message = res.message ? res.message : config.toasterMessages.otp.success;
    this.showToastMessage(message, 'success');
    return true
  }

  makeOtpSendApiCall(api: any, postParams: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpSrv.makePostApiCall(api, postParams, this.envService.baseUrl)
        .subscribe({
          next: (res) => {
            if (res.result) {
              return resolve(this.handleSuccess(res))
            }
            else {
              return resolve(false)
            }
          },
          error: (error) => {
            return resolve(false);
          }
        })
    })
  }

  handleValidateSuccess(res: any) {
    let config = this.intitSrv.getConfig(Config.OTP_FORGOT_PASSWD_CONFIG)
    let message = res.message ? res.message : config.toasterMessages.changePassword.success;
    this.showToastMessage(message, 'success');
    return true
  }

  makeOtpValidateApiCall(api: any, postParams: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpSrv.makePostApiCall(api, postParams, this.envService.baseUrl).subscribe({
        next: (res) => {
          if (res.result) {
            resolve(this.handleValidateSuccess(res));
          } else {
            resolve(false);
          }
        },
        error: (error) => {
          resolve(false); // Or you can reject with error if you prefer
        }
      });
    });
  }

  formatViewUsersData(data: any) {
    let sorted: any[] = [];

    if (data?.['viewUser']) {
      //* order of each attribute of user
      let listOrder = USER_MGMT_CNST.ORDER_FOR_VIEW_USERS;
      //* add order and key to each object
      Object.keys(listOrder).forEach(item => {

        data['viewUser'][item]['order'] = listOrder[item as keyof typeof listOrder];
        data['viewUser'][item]['key'] = item;
        //* change class for status alone
        if (item === 'status') {
          data['viewUser'][item]['class'] = 'col-12 mb-3';
        }

      })
      //* convert object into array of objects
      const arrayOfObj = Object.entries(data['viewUser']).map((e) => e[1]);
      //* sort array based on order
      sorted = [...arrayOfObj].sort((a: any, b: any) => a['order'] - b['order']);
    }

    //* return formatted data

    return sorted;

  }

  setUserPermissionsInLocalStorage(userPermissions: any, userMetaInfo: any) {
    if (this.envService.headerAppName === 'Connected Enterprise') {

      let permissionInLocalStorage = localStorage.getItem('userPermissions');
      let metaInfoInLocalStorage = localStorage.getItem('metaInfo');

      if (this.isObjectNotNullAndEmpty(userPermissions) && isNullOrUndefined(permissionInLocalStorage)) {
        localStorage.setItem('userPermissions', JSON.stringify(userPermissions));
      }

      if (this.isObjectNotNullAndEmpty(userMetaInfo) && isNullOrUndefined(metaInfoInLocalStorage)) {
        localStorage.setItem('metaInfo', JSON.stringify(userMetaInfo));
      }
    }
  }

  async logout() {
    if (this.keyCloakSrv.isLoggedIn()) {
      this.keyCloakSrv.logout();
    } else {
      this.keyCloakSrv.clearToken();
      this.router.navigate([environment.KEYCLOAK_URLS.LOGOUT_URL]);
    }
    this.authSrv.setUserInfo(null, (null as any));
    sessionStorage.clear();

    this.appStateSrv.setPermissionsLoaded(false);
    this.appStateSrv.setInProcess(false);
    this.appStateSrv.setUserMetaInfo({});
    this.appStateSrv.setUserPermissionsRef({});
  }

  isEmailValid(emailPattern: any, inputStr: string): boolean {
    if (!isNullOrUndefined(inputStr)) {
      return emailPattern.test(inputStr) && !/\.\.|\.@|@\.|^\./.test(inputStr);
    } else {
      return false;
    }
  }

  isObjectNotNullAndEmpty(inputObj: any): boolean {
    return !isNullOrUndefined(inputObj) && Object.keys(inputObj).length > 0;
  }

  buildMobileNumberWithCountryCode(countryCode: string, mobileNo: string) {
    if (!isNullOrUndefined(countryCode) && !isNullOrUndefined(mobileNo)) {
      return `${countryCode}-${mobileNo}`;
    }
    return null
  }

  splitByDelimiter(value: string, delimiter: string) {
    if (!isNullOrUndefined(value)) {
      return value.split(delimiter);
    }
    return null
  }

  breadcrumb!: MenuItem[] | null;
  breadcrumbRef = new Subject<MenuItem[] | null>();

  getbreadcrumb() {
    return this.breadcrumb || typeof window !== 'undefined' && sessionStorage ? JSON.parse(sessionStorage.getItem('breadcrumb') ?? '[]') : [];
  }

  setbreadcrumb(data: MenuItem[] | null) {
    this.breadcrumb = data;
    this.breadcrumbRef.next(this.breadcrumb);
    if (typeof window !== 'undefined' && sessionStorage) {
      sessionStorage.setItem('breadcrumb', JSON.stringify(this.breadcrumb));
    }
  }

  /**
  * Update Breadcrumb Data
  * @param index 
  */
  removeBreadCrumb(index: any) {
    this.breadcrumb = this.breadcrumb ? this.breadcrumb : JSON.parse(sessionStorage.getItem('breadcrumb') ?? '[]')
    if (this.breadcrumb) {
      let breadcrumb = this.breadcrumb.slice(0, index + 1);
      this.setbreadcrumb(breadcrumb);
    }
  }


  blobToBase64(blob: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64String = reader.result;
        resolve(base64String);
      };
      reader.onerror = (error) => {
        reject(new Error('Failed to read blob: '));
      };
    });
  }

  generateRandomFileName(originalFileName: string): string {
    const array = new Uint8Array(7);
    window.crypto.getRandomValues(array);// Fill the array with cryptographically secure random values
    const randomString = Array.from(array, byte => byte.toString(32).padStart(2, '0')).join('').substring(2, 10);
    const timestamp = Date.now(); // Get the current timestamp
    const extension = originalFileName.split('.').pop(); // Extract the file extension    
    return `${randomString}_${timestamp}.${extension}`;
  }

  getMetaInfoFromLocalStorage() {
    return JSON.parse(localStorage.getItem('metaInfo') ?? '{}');
  }

  // validateMobileNumber(control: FormControl, country: any): { [key: string]: boolean } | null {
  //   const phoneNumberValue = control.value;
  //   if (!country || typeof phoneNumberValue !== 'string' || !phoneNumberValue.trim()) {
  //     return null;
  //   }
  //   try {
  //     const phoneNumber = parsePhoneNumberFromString(phoneNumberValue, country.code);
  //     return phoneNumber?.isValid() ? null : { invalidPhoneNumber: true };
  //   } catch (error) {
  //     return { invalidPhoneNumber: true };
  //   }
  // }

  convertSvgFileToPng(svgFile: File): Promise<File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const svgContent = reader.result as string;
        const svgBlob = new Blob([svgContent], { type: 'image/svg+xml' });
        const url = URL.createObjectURL(svgBlob);

        // Call the separated function for image loading and PNG conversion
        this.loadImageAndConvertToPng(url, svgFile.name)
          .then((pngFile) => {
            URL.revokeObjectURL(url);  // Cleanup object URL immediately
            resolve(pngFile);
          })
          .catch((error) => {
            URL.revokeObjectURL(url);  // Cleanup object URL on error
            reject(new Error(error));
          });
      };

      reader.onerror = () => reject(new Error('File reading error'));
      reader.readAsText(svgFile);  // Read SVG as text
    });
  }

  private loadImageAndConvertToPng(imageUrl: string, fileName: string): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          canvas.toBlob((pngBlob) => {
            if (pngBlob) {
              resolve(new File([pngBlob], `${fileName.split('.')[0]}.png`, { type: 'image/png' }));
            } else {
              reject(new Error('Failed to create PNG blob'));
            }
          }, 'image/png');
        } else {
          reject(new Error('Canvas context is null'));
        }
      };

      img.onerror = () => reject(new Error('Invalid SVG content'));
      img.src = imageUrl;  // Start image loading
    });
  }

  replaceFileInputWithNewFile(file: File): void {
    const fileInput = document.getElementById('fileUploadCustom') as HTMLInputElement;
    if (fileInput) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      fileInput.files = dataTransfer.files;

      // Dispatch the 'change' event to trigger file handling
      fileInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  //use to restrict the user access the stepper
  disableStepper(isDisable?: boolean) {
    const elements = document.getElementsByClassName('p-stepper-action');
    if (!isDisable) {
      elements[2]?.classList.add('p-disabled');
    } else {
      elements[2]?.classList.remove('p-disabled');
    }
  }

  restrictedEmailCharactersValidator(control: AbstractControl): ValidationErrors | null {
    const email = control.value;
  
    if (!email) return null; // Allow empty values – let 'required' handle that if needed
  
    const hasForbiddenCharacters = /[%+]/.test(email);
    const hasMultipleUnderscoresOrHyphens = /(__|--)/.test(email);
    const hasLeadingOrTrailingSpaces = email !== email.trim();
  
    const errors: ValidationErrors = {};
  
    if (hasForbiddenCharacters) {
      errors['forbiddenCharacters'] = true;
    }
  
    if (hasMultipleUnderscoresOrHyphens) {
      errors['multipleSpecialCharacters'] = true;
    }
  
    if (hasLeadingOrTrailingSpaces) {
      errors['leadingOrTrailingSpaces'] = true;
    }
  
    return Object.keys(errors).length ? errors : null;
  }
  restrictedEmailLengthValidator(control: AbstractControl): ValidationErrors | null {
    const CharactersLength = /^[a-zA-Z0-9._%+-]+@[a-z0-9-]{64,}\.[a-z]{2,4}$/;
    const email = control.value;

    if (email && CharactersLength.test(email)) {
      return { CharactersLength: true }; // Return error if any of these characters are present
    }

    return null;
  }

  setLoaderState(active: boolean): void {
    if (active) {
      this.activeSpinnerCount++;
    } else {
      this.activeSpinnerCount = Math.max(0, this.activeSpinnerCount - 1);
    }
    this.loader.set(this.activeSpinnerCount > 0);
  }

  getDataInChunks(blobName: string, mimeType: string): Observable<string | null> {
    const postData = { blob_url: blobName };

    return this.httpSrv.makePostApiCallForDownload('STREAM_FILE', postData, environment.urlMapping.PROJ_API).pipe(
      takeUntil(this.destroy$), // Stop the stream if the component is destroyed
      map((data: any) => {
        const blob = new Blob([data], { type: mimeType });
        return URL.createObjectURL(blob); // Return the URL
      }),
      catchError(() => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch the file. Please try again.',
        });
        return of(null); // Return null in case of an error
      })
    );
  }

  async getDataUrl(fileUrl: string, mimeType: string): Promise<string> {
    try {
      const url = await lastValueFrom(
        this.getDataInChunks(fileUrl, mimeType).pipe(takeUntil(this.destroy$))
      );
      return url || ''; // Return the URL or an empty string if the URL is falsy
    } catch (error) {
      console.error('Error fetching data URL:', error);
      return ''; // Return an empty string in case of an error
    }
  }

  /**
   * Get MIME type based on file extension
   */
  getMimeTypeFromExtension(extension: string): string {
    const mimeTypes: Record<string, string> = {
      'pdf': 'application/pdf',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'xls': 'application/vnd.ms-excel',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'json': 'application/json',
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'csv': 'text/csv',
      'txt': 'text/plain',
      'zip': 'application/zip',
      'ctf': 'application/octet-stream',
      'slf': 'application/octet-stream'
    };
    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }

  /**
   * Download a file from Azure blob storage
   * @param blobUrl - The blob URL/path in Azure storage
   * @param fileName - Optional custom filename for download. If not provided, extracts from blobUrl
   * @returns Promise<boolean> - Returns true if download succeeded, false otherwise
   */
  async downloadFileFromAzure(blobUrl: string, fileName?: string): Promise<boolean> {
    if (!blobUrl) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No file URL provided.' });
      return false;
    }

    try {
      // Extract filename from URL if not provided
      const downloadFileName = fileName || blobUrl.split('/').pop() || 'downloaded-file';

      // Get file extension and MIME type
      const extension = downloadFileName.split('.').pop() || '';
      const mimeType = this.getMimeTypeFromExtension(extension);

      // Get the file URL using existing method
      const fileObjectUrl = await this.getDataUrl(blobUrl, mimeType);

      if (!fileObjectUrl) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to download file.' });
        return false;
      }

      // Fetch the blob from the object URL and save
      const response = await fetch(fileObjectUrl);
      const blob = await response.blob();
      saveAs(blob, downloadFileName);

      // Cleanup the object URL
      URL.revokeObjectURL(fileObjectUrl);

      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'File downloaded successfully.' });
      return true;
    } catch (error) {
      console.error('Error downloading file from Azure:', error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to download file.' });
      return false;
    }
  }



  formattedUserPermission(data: any) {
    Object.keys(data).forEach(appName => {
      const appDetails = data[appName].applicationDetailsJson;
      if (appDetails && appDetails.logo) {
        this.getDataInChunks(appDetails.logo, 'image/jpg').pipe(takeUntil(this.destroy$)).subscribe({
          next: (url) => {
            if (url) {
              appDetails.logo = url;
            } else {
              appDetails.logo = '';
            }
          },
          error: (err) => {
            appDetails.logo = '';
            console.log('Unexpected error:', err);
          },
        });
      }
    });
    return data;
  }

  /**
 * Recursively checks if two objects (including JSON structures) are deeply equal.
 * This ensures that all keys, values, and nested objects are identical.
 * 
 * @param obj1 - First object to compare
 * @param obj2 - Second object to compare
 * @returns boolean - Returns true if both objects are deeply equal, otherwise false
 */
   deepCompareJson(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true; // If both references are the same
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return false; // If either is not an object or is null
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false; // If keys length differs
    for (const key of keys1) {
      if (!keys2.includes(key) || !this.deepCompareJson(obj1[key], obj2[key])) {
        return false; // If key is missing in obj2 or values are not deeply equal
      }
    }
    return true;
  }

  letterDateFormatValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
  
    // Match exactly 3 parts separated by the same delimiter
    const match = value.match(/^([a-zA-Z]{2,4})([-\/])([a-zA-Z]{2,4})\2([a-zA-Z]{2,4})$/);
    if (!match) {
      return { invalidDateFormat: true };
    }
  
    const parts = [match[1], match[3], match[4]];
    const yearCount = parts.filter(p => /^y{4}$/i.test(p)).length;
    const monthCount = parts.filter(p => /^m{2}$/i.test(p)).length;
    const dayCount = parts.filter(p => /^d{2}$/i.test(p)).length;
  
    if (yearCount !== 1 || monthCount !== 1 || dayCount !== 1) {
      return { invalidDateFormat: true };
    }
  
    return null;
  }
}
